import type { TenantConfig } from '@/types/TenantConfig'

export const gracefarms: TenantConfig = {
  logo: 'assets/gracefarms/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#edebe9',
      headerBorder: '0',
    },
  },
  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/gracefarms/static/completed-desktop.jpg',
        mobile: 'assets/gracefarms/static/completed-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-250px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/gracefarms/static/fonts.css',
    },
  },
}
